import '../assets/_variables.css';
import XmlViewer from './XmlViewer'

export default XmlViewer